<script setup lang="ts">
import {ref} from "vue";
import {
    NotificationTemplate as INotificationTemplate,
} from "@/notification-template/interfaces";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";
import TryRcsDialog from "@/rcs/components/try-dialog/TryRcsDialog.vue";
import RcsTagSelect from "@/rcs/components/RcsTagSelect.vue";
import {useRcsTemplates} from "@/rcs/composables/useRcsTemplates";
import NotificationTemplateSection from "@/rcs/components/tabs/NotificationTemplateSection.vue";

const {tags, selectedTag, sections, initialLoading, selectTag, refreshing, templatesLoading} = useRcsTemplates();

const selectedTemplate = ref<INotificationTemplate | undefined>();
</script>

<template>
  <BaseFlexSpinner v-if="initialLoading" />
  <div v-else class="flex flex-col gap-12 mt-4">
    <Teleport defer to="#rcs-tag-select">
      <RcsTagSelect
        v-if="tags?.length"
        v-model="selectedTag"
        :tags="tags ?? []"
        @update:model-value="selectTag"
      />
    </Teleport>
    <BaseFlexSpinner v-if="refreshing || templatesLoading" />
    <template v-else>
      <NotificationTemplateSection
        v-for="section in sections"
        :key="section.tag?.id ?? 'generic'"
        :tag="section.tag"
        :templates="section.templates"
        @template-selected="_template => selectedTemplate = _template"
      />
    </template>

    <TryRcsDialog v-model:model-value="selectedTemplate" />
  </div>
</template>
